import { render, staticRenderFns } from "./orgSideIcon.vue?vue&type=template&id=3beeb572&"
import script from "./orgSideIcon.vue?vue&type=script&lang=js&"
export * from "./orgSideIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports